// SVG flag CDN: https://flagcdn.com (reliable, free, no API key)
// Flag codes use ISO 3166-1 alpha-2
const NATIONALITIES = [
  { ja: '日本', en: 'Japan', code: 'jp' },
  { ja: '中国', en: 'China', code: 'cn' },
  { ja: '韓国', en: 'South Korea', code: 'kr' },
  { ja: 'ベトナム', en: 'Vietnam', code: 'vn' },
  { ja: 'フィリピン', en: 'Philippines', code: 'ph' },
  { ja: 'インドネシア', en: 'Indonesia', code: 'id' },
  { ja: 'タイ', en: 'Thailand', code: 'th' },
  { ja: 'ミャンマー', en: 'Myanmar', code: 'mm' },
  { ja: 'カンボジア', en: 'Cambodia', code: 'kh' },
  { ja: 'ネパール', en: 'Nepal', code: 'np' },
  { ja: 'インド', en: 'India', code: 'in' },
  { ja: 'バングラデシュ', en: 'Bangladesh', code: 'bd' },
  { ja: 'スリランカ', en: 'Sri Lanka', code: 'lk' },
  { ja: 'パキスタン', en: 'Pakistan', code: 'pk' },
  { ja: 'モンゴル', en: 'Mongolia', code: 'mn' },
  { ja: '台湾', en: 'Taiwan', code: 'tw' },
  { ja: 'ブラジル', en: 'Brazil', code: 'br' },
  { ja: 'ペルー', en: 'Peru', code: 'pe' },
  { ja: 'アメリカ', en: 'USA', code: 'us' },
  { ja: 'イギリス', en: 'UK', code: 'gb' },
  { ja: 'その他', en: 'Other', code: null },
];

export const getFlagUrl = (code) => code ? `https://flagcdn.com/20x15/${code}.png` : null;

export default NATIONALITIES;
